import { render, staticRenderFns } from "./TemplateList.vue?vue&type=template&id=72adb611&scoped=true&"
import script from "./TemplateList.vue?vue&type=script&lang=js&"
export * from "./TemplateList.vue?vue&type=script&lang=js&"
import style0 from "./TemplateList.vue?vue&type=style&index=0&id=72adb611&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72adb611",
  null
  
)

export default component.exports